import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import TopbarUserProfile from './profile';
import RightSidebar from '../right-sidebar';
import { useLanguage } from '../../services/language/LanguageContext';

const Topbar = () => {
  const [showRightSideBar, setShowRightSideBar] = useState(false);
  const { lang, toggleLang, t } = useLanguage();

  const handleToggleNav = () => {
    const rootNodeChildren = document.getElementById('root').children;
    for (let i = 0; i < rootNodeChildren.length; i++) {
      if (rootNodeChildren[i].classList.contains('nav-collapsed')) {
        rootNodeChildren[i].classList.remove('nav-collapsed');
      } else {
        rootNodeChildren[i].classList.add('nav-collapsed');
      }
    }
  };

  return (
    <>
      <div className="top-bar primary-top-bar">
        <div style={styles.inner}>
          {/* Left: Logo + Toggle */}
          <div style={styles.left}>
            <button style={styles.toggleBtn} onClick={handleToggleNav} title="Toggle sidebar">
              <i className="fa fa-bars" />
            </button>
            <Link to="/dashboard" style={styles.logoLink}>
              <span className="topbar-logo-text" style={styles.logoText}>เพื่อนรับเหมา</span>
              <span className="topbar-logo-badge" style={styles.logoBadge}>{t('logo_badge')}</span>
            </Link>
          </div>

          {/* Right: Actions + Profile */}
          <ul className="list-inline top-right-nav" style={{ marginBottom: 0, display: 'flex', alignItems: 'center', gap: 4 }}>
            {/* Language Toggle */}
            <li className="list-inline-item">
              <button
                onClick={toggleLang}
                title={lang === 'th' ? 'Switch to English' : 'เปลี่ยนเป็นภาษาไทย'}
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: 5,
                  background: 'rgba(255,255,255,0.12)',
                  borderRadius: 8, padding: '4px 10px',
                  cursor: 'pointer', color: '#fff',
                  fontSize: 11, fontWeight: 700, letterSpacing: '0.05em',
                  transition: 'background 0.15s',
                }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.22)'}
                onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.12)'}
              >
                <i className="fa fa-globe" style={{ fontSize: 12 }} />
                {lang === 'th' ? 'TH' : 'EN'}
              </button>
            </li>

            {/* Chat */}
            <li
              className="list-inline-item"
              title={t('nav_chat')}
              style={{ cursor: 'pointer' }}
              onClick={() => setShowRightSideBar(!showRightSideBar)}
            >
              <a className="right-sidebar-toggle" href="#chat" onClick={(e) => e.preventDefault()}>
                <i className="fa fa-comments" />
              </a>
            </li>

            <TopbarUserProfile />
          </ul>
        </div>
      </div>

      <RightSidebar show={showRightSideBar} />
    </>
  );
};

const styles = {
  inner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 20px',
    height: '100%',
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  toggleBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: 'rgba(255,255,255,0.85)',
    fontSize: 18,
    padding: '4px 8px',
    borderRadius: 6,
    transition: 'background 0.15s',
    lineHeight: 1,
  },
  logoLink: {
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  logoText: {
    color: '#fff',
    fontSize: 18,
    fontWeight: 700,
    letterSpacing: '-0.02em',
  },
  logoBadge: {
    background: 'rgba(255,255,255,0.2)',
    color: 'rgba(255,255,255,0.9)',
    fontSize: 11,
    fontWeight: 600,
    padding: '2px 8px',
    borderRadius: 20,
    letterSpacing: '0.05em',
  },
};

export default Topbar;
